import type { ReactNode } from 'react'

interface FormFieldProps {
  label: string
  error?: string
  required?: boolean
  helper?: string
  counter?: { current: number; max: number }
  children: ReactNode
}

export function FormField({ label, error, required, helper, counter, children }: FormFieldProps) {
  const showCounter = counter !== undefined
  const counterNearMax = showCounter && counter.current > counter.max * 0.9

  return (
    <div className="space-y-1.5">
      <div className="flex items-baseline justify-between gap-2">
        <label className="block text-sm font-medium text-text">
          {label}
          {required && <span className="text-danger ml-0.5">*</span>}
        </label>
        {showCounter && (
          <span
            className={
              counterNearMax
                ? 'text-xs tabular-nums text-danger'
                : 'text-xs tabular-nums text-text-subtle'
            }
          >
            {counter.current}/{counter.max}
          </span>
        )}
      </div>
      {children}
      {helper && !error && <p className="text-xs text-text-subtle">{helper}</p>}
      {error && <p className="text-xs text-danger">{error}</p>}
    </div>
  )
}

const baseInputClasses =
  'w-full rounded-md border border-input bg-bg-elevated px-3 py-2 text-sm text-text placeholder:text-text-subtle outline-none transition-colors focus:border-ring focus:ring-2 focus:ring-ring/30 disabled:opacity-50'

export const inputClasses = baseInputClasses
export const textareaClasses = `${baseInputClasses} min-h-[120px] resize-y`
export const selectClasses = `${baseInputClasses} appearance-none pr-8 cursor-pointer`
